rdefine("app/clients/ConfigureMessageTab",['backbone',
    'text!clients/configurator-messages.html',
    'app/formular/components/Tabs'], function(Backbone, template, Tabs) {

    var ConfigureMessageTabItself = Backbone.Ribs.View.extend({
        tagName:'div',
        bindings:{
            /*'.off-moderation':{
                toggle:{
                    data:'model.premoderation',
                    processor:function(v) {
                        return !v;
                    }
                }
            },
            '.on-moderation':{
                toggle:{
                    data:'model.premoderation',
                    processor:function(v) {
                        return v;
                    }
                }
            },*/
            '.login-sms-show':{
                toggle:{
                    data:'model.config_login_field_type',
                    processor:function(v){
                        return false;
                        return v === 'sms';
                    }
                }
            },/*
            '.login-email-show':{
                toggle:{
                    data:'model.config_login_field_type',
                    processor:function(v){
                        return v !== 'sms';
                    }
                }
            },*/
            'textarea[name=sms-activation]':{
                value:'lmodel.sms-activation'
            },
            'textarea[name=sms-moderation]':{
                value:'lmodel.sms-moderation'
            },
            'textarea[name=sms-decline]':{
                value:'lmodel.sms-decline'
            },
            'textarea[name=sms-complete]':{
                value:'lmodel.sms-complete'
            },
            'textarea[name=email-activation]':{
                value:'lmodel.email-activation'
            },
            'textarea[name=email-welcome]':{
                value:'lmodel.email-welcome'
            },
            'textarea[name=email-moderation]':{
                value:'lmodel.email-moderation'
            },
            'textarea[name=email-decline]':{
                value:'lmodel.email-decline'
            },

            'input[name=email-activation-subject]':{
                value:'lmodel.email-activation-subject'
            },
            'input[name=email-welcome-subject]':{
                value:'lmodel.email-welcome-subject'
            },
            'input[name=email-moderation-subject]':{
                value:'lmodel.email-moderation-subject'
            },
            'input[name=email-decline-subject]':{
                value:'lmodel.email-decline-subject'
            }
        },
        initialize:function(options) {
            console.log('testtest',options.model.attributes);
            this.lang = options.lang;
            this.lmodel = new Backbone.Ribs.Model({});
            this.$el.html(Template7.compile(template)());
            var messages = this.model.get('messages',{});
            if(_.keys(messages).indexOf(this.lang)===-1) {
                this.model.set('messages.'+this.lang, {});
            }
            console.log('set messages object',this.model.get('messages.'+this.lang));
            this.lmodel.set(this.model.get('messages.'+this.lang));
            this.lmodel.on('change', function(){
                console.log('lmodel', this.lmodel.attributes);
                this.model.set('messages.'+this.lang, this.lmodel.attributes);
            }.bind(this));
            var cfg={
                disableDragAndDrop: true,
                toolbar: [
                    ['style', ['style']],
                    ['font', ['bold', 'underline', 'clear']],
                    ['color', ['color']],
                    ['para', ['ul', 'ol']],
                    ['insert',['picture','link']],
                    ['view', ['fullscreen', 'codeview']]
                ],
                onChange: function(e) {
                    //set dirty
                    console.log("sd",e);
                    this.cform.set('property_'+this.model.get("id"))
                }.bind(this),
                callbacks: {
                    onImageUpload: function (files, editor, welEditable) {
                        $.each(files, function (i, file) {
                            sendFile(file, editor, welEditable, sn);
                        });
                        return false;
                    }
                },
                cleaner:{
                    notTime: 0, // Time to display Notifications.
                    action: 'both', // both|button|paste 'button' only cleans via toolbar button, 'paste' only clean when pasting content, both does both options.
                    newline: '<br>', // Summernote's default is to use '<p><br></p>'
                    notStyle: 'position:absolute;top:0;left:0;right:0', // Position of Notification
                    icon: '<i class="note-icon">[Your Button]</i>',
                    keepHtml: true, // Remove all Html formats
                    keepOnlyTags: ['<p>', '<br>', '<ul>', '<li>', '<b>', '<strong>','<i>', '<a>'], // If keepHtml is true, remove all tags except these
                    keepClasses: false, // Remove Classes
                    badTags: ['style', 'script', 'applet', 'embed', 'noframes', 'noscript', 'html'], // Remove full tags with contents
                    badAttributes: ['style', 'start'] // Remove attributes from remaining tags
                },
                height:150
            };
            this.$el.find('.summernote-enable').each(function() {
                setTimeout(function(){
                    $(this).summernote(cfg);
                }.bind(this),300);

            });

        }
    });

    return Backbone.Ribs.View.extend({
        tagName:'div',
        initialize: function(options) {
            this.languages = options.languages;
            if(!this.model.has('messages')) {
                this.model.set('messages',{});
            }

            var tabs = [

            ];
            _.each(this.languages, function(language) {

                tabs.push({
                    title:language.lang.name,
                    module:ConfigureMessageTabItself,
                    options:{
                        lang:language.lang.shortname,
                        model:options.model
                    }
                })
            });

            console.log(tabs);


            this.tabs = new Tabs({
                tabs:tabs
            });
            this.$el.append(this.tabs.el);
        }
    });
});